export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of Korean. All those symbols looked impossible. After day 5 with K-Smart I could read my first Hangul sentence without help. By week 3 I was watching K-Dramas and catching actual words. This system is a complete game-changer.',
    name: 'Jessica M.',
    location: 'Los Angeles · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      'I watched K-Dramas for 2 years frustrated because I understood NOTHING. I tried an app for 6 months with no real progress. The K-Smart method actually works. I am now in the Discord community talking with real Koreans.',
    name: 'Carlos L.',
    location: 'Buenos Aires · Argentina',
    flag: '🇦🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      'I was afraid I was not “good at languages”. K-Smart proved me wrong. The visual method makes everything so clear. I felt progress from DAY ONE, which kept me motivated. I recommend it to every K-Pop fan I know.',
    name: 'Maria G.',
    location: 'Madrid · Spain',
    flag: '🇪🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The flashcards live on my phone now. I review Hangul on the bus and I already read menus and signs in K-Dramas before the subtitles appear.',
    name: 'Chloe R.',
    location: 'Sydney · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      'Hangul Express did it in two evenings. I had tried three times before with videos and always gave up. Seeing the syllable blocks explained visually finally made it click.',
    name: 'Julia M.',
    location: 'Manchester · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'The 30-day calendar is what kept me consistent. 30 minutes a day, no guessing what to study. Day 28 I sent my first message in Korean to a friend in Seoul.',
    name: 'Noah A.',
    location: 'Chicago · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
  {
    quote:
      'I bought it for the K-Pop lyrics and stayed for the community. The Discord has native speakers who correct your pronunciation. Worth far more than $19.',
    name: 'Sophie L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
